import "./styles.scss";

import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";

import useResponsive from "libs/helpers/useResponsive";

const className = "task-view-input-edit";

const InputEdit = ({ initialValue, onClose, onSave }) => {
  const { t } = useTranslation();
  const { max } = useResponsive();

  const [value, setValue] = useState(initialValue ?? "");
  const textareaRef = useRef(null);

  const resizeTextarea = () => {
    if (textareaRef.current) {
      textareaRef.current.style.height = "auto";
      textareaRef.current.style.height = `${textareaRef.current.scrollHeight + 2}px`;
    }
  };

  useEffect(() => {
    if (!max.lg) return undefined;

    resizeTextarea();
    window.addEventListener("resize", resizeTextarea);
    return () => window.removeEventListener("resize", resizeTextarea);
  }, [max.lg]);

  const handleSave = () =>
    typeof onSave === "function" ? onSave(value) : undefined;

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      handleSave();
    }
  };

  const handleTabletKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleSave();
    }
  };

  const handleChange = (e) => {
    setValue(e.target.value.replace(/\n/g, "").replace(/ {2,}/g, " "));
    resizeTextarea();
  };

  if (max.lg) {
    return (
      <div className={`${className} ${className}--tablet`}>
        <div className={`${className}__field`}>
          <textarea
            ref={textareaRef}
            value={value}
            rows={1}
            onKeyDown={handleTabletKeyDown}
            onChange={handleChange}
          />
        </div>
        <div className={`${className}__actions`}>
          <button type="button" onClick={onClose}>
            {t("Cancel")}
          </button>
          <button type="button" onClick={handleSave}>
            {t("Save")}
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className={className}>
      <div className={`${className}__field`}>
        <input
          type="text"
          value={value}
          onKeyDown={handleKeyDown}
          onChange={(e) =>
            setValue(e.target.value.replace(/\n/g, "").replace(/ {2,}/g, " "))
          }
        />
        <button type="button" onClick={onClose} />
      </div>
      <button type="button" onClick={handleSave}>
        {t("Save")}
      </button>
    </div>
  );
};

export default InputEdit;
